import { Outlet } from 'react-router-dom';
import { Footer } from './Footer.jsx';
import { Navbar } from './Navbar.jsx';

export const PublicLayout = () => (
  <div className="min-h-screen bg-beam-light">
    <Navbar />
    <main>
      <Outlet />
    </main>
    <Footer />
  </div>
);
